import { useCallback } from 'onyx-common/use-memo-one'

export default useCallback
